import { useDisciplineStore } from '@stores/discipline'

import { useCustomerShowApi } from '@api/customer/show.hook'
import { useDisciplineTaskCommentsApi } from '@api/discipline-task-comments/comments.hook'
import { parseFilterParams } from '@hooks/discipline-task-comments/filter-params'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const disciplineStore = useDisciplineStore()
  const customerId = disciplineStore.getCustomerId

  if (!customerId) return

  await useCustomerShowApi({ customerId })

  const filters = parseFilterParams(to.query)
  const disciplineIdFilter = filters.discipline_id.length
    ? filters.discipline_id
    : []

  void useDisciplineTaskCommentsApi({
    customerId,
    disciplineId: disciplineIdFilter,
    createdFrom: filters.created_from,
    createdTo: filters.created_to,
  })
})
